// @flow

import * as React from 'react';
import ResponsiveImage from 'components/ResponsiveImage/ResponsiveImage';
import type { Event } from 'type/type';

import EventProfile from './EventProfile/EventProfile';
import img from './hero_img_default.jpg';
import thumbnail from './hero_image_thumbnail.jpg';
import './EventHeader.scss';
import './EventHeaderWhiteLabelDefaultSettings.scss';

type Props = {
  raceEvent?: ?Event,
  locale: string,
  whiteLabelHeader: ?string
}

export const EventHeader = ({ raceEvent, locale, whiteLabelHeader }: Props) => {
  return raceEvent ? (
    <div className="event-header">
      {
        whiteLabelHeader
          ? <div className="event-header-whitelabel" dangerouslySetInnerHTML={{ __html: whiteLabelHeader }} /> // eslint-disable-line
          : <ResponsiveImage src={raceEvent.heroImage || img} thumbnail={raceEvent.heroImageThumbnail || thumbnail} aspectRatio="25%" designedLandscapeMobileHeight={192} />
      }
      <EventProfile raceEvent={raceEvent} locale={locale} />
    </div>
  ) : null;
};

EventHeader.defaultProps = {
  raceEvent: null,
};

export default EventHeader;
